import React from "react";

const baseStyle = {
  width: "100%",
  padding: "var(--sp-2) var(--sp-3)",
  background: "var(--bg0)",
  border: "1px solid var(--bdr)",
  borderRadius: 9,
  color: "var(--t1)",
  fontSize: 13,
  outline: "none",
  transition: "border-color 0.2s",
  fontFamily: "'Outfit', sans-serif",
};

export default function Input({ label, error, style = {}, ...props }) {
  return (
    <label style={{ display: "block", marginBottom: 12 }}>
      {label && (
        <span
          style={{
            display: "block",
            fontSize: 10,
            fontWeight: 600,
            color: "var(--t3)",
            marginBottom: "var(--sp-1)",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
          }}
        >
          {label}
        </span>
      )}
      <input
        style={{
          ...baseStyle,
          ...(error ? { borderColor: "var(--red)" } : {}),
          ...style,
        }}
        aria-invalid={error ? "true" : undefined}
        {...props}
      />
      {error && (
        <span style={{ fontSize: 11, color: "var(--red)", marginTop: 4, display: "block" }}>
          {error}
        </span>
      )}
    </label>
  );
}
